import { useNavigate, type NavigateOptions } from 'react-router-dom';
import { useCallback } from 'react';

export function useNavigateWithParams() {
  const navigate = useNavigate();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      const search = window.location.search;
      // If `to` already has query params, merge them; otherwise append
      const separator = to.includes('?') ? '&' : '?';
      const fullPath = search ? `${to}${separator}${search.substring(1)}` : to;
      navigate(fullPath, options);
    },
    [navigate]
  );
}
